const guestForm = document.querySelector('.sc-purchase-process-03-guest form');
if (guestForm) {
  const setUserDataCookie = () => {
    const userData = {};
    const guestFormSubmit = document.querySelector('.purchase-process-03-guest__footer .btn--default');
    if (guestFormSubmit) {
      guestFormSubmit.addEventListener('click', (ev) => {
        const formInputs = guestForm.querySelectorAll('input');
        formInputs.forEach((input) => {
          userData[input.name] = input.value;
        });
        setCookie('wp_guestUserData', JSON.stringify(userData), 1);
      });
    }
  };

  const cookie = getCookie('wp_guestUserData');
  if (cookie) {
    const cookieData = cookie;
    const formInputs = guestForm.querySelectorAll('input');
    formInputs.forEach((input) => {
      // eslint-disable-next-line no-param-reassign
      input.value = cookieData[input.name];
    });
  }
  setUserDataCookie();
}

document.addEventListener('DOMContentLoaded', () => {
  const userForm = document.querySelector('.sc-purchase-process-03-user form');
  if (userForm) {
    userForm.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      if (checkbox.checked) {
        const checkboxLabel = `${checkbox.name.replace('_', '-')}-fields`;
        userForm.querySelector(`.${checkboxLabel}`).classList.remove('hide');
      }
    });
  }
});
